import { AppInfo } from "@dimensional-engineering/dimensional-models";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

type AppInfoSlice = {
  appInfo: AppInfo | null;
  premiumLocalizedPrice: string;
  premiumPeriodLabel: string;
  consumableSmallLocalizedPrice: string;
  consumableMediumLocalizedPrice: string;
};

const initialState: AppInfoSlice = {
  appInfo: null,
  premiumLocalizedPrice: "$19.99",
  premiumPeriodLabel: "",
  consumableSmallLocalizedPrice: "$3.99",
  consumableMediumLocalizedPrice: "$11.99",
};

export const appInfoSlice = createSlice({
  name: "appInfo",
  initialState: initialState,
  reducers: {
    setAppInfo: (state, action: PayloadAction<AppInfo>) => {
      return { ...state, appInfo: action.payload };
    },
    setPremiumLocalizedPrice: (state, action: PayloadAction<string>) => {
      return { ...state, premiumLocalizedPrice: action.payload };
    },
    setPremiumPeriodLabel: (state, action: PayloadAction<string>) => {
      return { ...state, premiumPeriodLabel: action.payload };
    },
    setConsumableSmallLocalizedPrice: (
      state,
      action: PayloadAction<string>
    ) => {
      return { ...state, consumableSmallLocalizedPrice: action.payload };
    },
    setConsumableMediumLocalizedPrice: (
      state,
      action: PayloadAction<string>
    ) => {
      return { ...state, consumableMediumLocalizedPrice: action.payload };
    },
  },
});

export const {
  setAppInfo,
  setPremiumLocalizedPrice,
  setPremiumPeriodLabel,
  setConsumableSmallLocalizedPrice,
  setConsumableMediumLocalizedPrice,
} = appInfoSlice.actions;

export default appInfoSlice.reducer;
